import React, { useEffect, useState, Suspense } from 'react';
import PropTypes from 'prop-types';


// Ideally LazyIcon would be using React.lazy & lazyWithRetry
function withLazyIconFallback(LazyIcon) {
    function WrapperComponent({ 
        className, 
        width, 
        height, 
        ...otherComponentProps 
    }) {
        const [ showFallback, setShowFallback ] = useState(true);  

        // We only want to render our lazy icon + Suspense client side
        //  This is due to Suspense's interaction with our static site generation
        //  it's expecting a server to respond but our system doesn't have that.
        useEffect(() => {
            setShowFallback(false);
        }, []);

        // Fix for layout jank with lazy loaded icons
        // If we're provided one of width or height, assume our size is a square and set the other size
        const fallbackWidth = width ?? height ?? '100%';
        const fallbackHeight = height ?? width ?? '100%';
        
        // If the icon is supplied a size either via rh-icon-* class name or width/height props
        //  we want this to also apply to our fallback so the size remains the same before the
        //  icon loads.
        const style = className && className.includes('rh-icon-')
            ? {}
            : { width: fallbackWidth, height: fallbackHeight };

        const fallback = (
            <span
                className={className}
                style={style}
            />
        );

        return (
            <Choose>
                <When condition={showFallback}>
                    {fallback}
                </When>
                <Otherwise>
                    {/* Render Suspense only client-side. This is because React.lazy requires
                        a Suspense boundary and there's no way for us to know when a lazy
                        component is resolved otherwise. */}
                    <Suspense fallback={fallback}>
                        <LazyIcon 
                            className={className}
                            width={width}
                            height={height}
                            {...otherComponentProps} 
                        />
                    </Suspense>
                </Otherwise>
            </Choose>
        );
    }

    WrapperComponent.propTypes = {
        className: PropTypes.string,
        width: PropTypes.oneOfType([ 
            PropTypes.string,
            PropTypes.number,
        ]),
        height: PropTypes.oneOfType([ 
            PropTypes.string,
            PropTypes.number,
        ]),
    };

    return WrapperComponent;
}

export default withLazyIconFallback;